import { CreateAlert } from '../../../shared/common-alerts/SKAlerts';

export const validateVendor = (payload, setAlert) => {
  if (!payload.VendorName?.trim()) {
    CreateAlert('Please enter vendor name!!', 'Warning', setAlert);
    return false;
  }
  if (payload.Email?.trim()) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(payload.Email.trim())) {
      CreateAlert('Please enter a valid email address!!', 'Warning', setAlert);
      return false;
    }
  }
  if (payload.Rating !== '' && payload.Rating != null) {
    const rating = Number(payload.Rating);
    if (Number.isNaN(rating) || rating < 0 || rating > 5) {
      CreateAlert('Rating must be between 0 and 5!!', 'Warning', setAlert);
      return false;
    }
  }
  if (payload.ReviewCount !== '' && payload.ReviewCount != null) {
    const reviewCount = Number(payload.ReviewCount);
    if (Number.isNaN(reviewCount) || reviewCount < 0) {
      CreateAlert('Review count cannot be negative!!', 'Warning', setAlert);
      return false;
    }
  }
  return true;
};
